import Typography, { TypographyVariant } from '@ben/orion/typography';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../shared/constants';
import ModelDropdown from '../model-select/model-dropdown';
import type { ITagsSelect } from '../tags/tags-select';
import TagsSelect from '../tags/tags-select';
import CountriesSelect from './countries-select';

interface IReportingSection {
  tagsSelectProps: ITagsSelect;
}

const ReportingSection = ({ tagsSelectProps }: IReportingSection) => {
  const { control } = useFormContext();
  return (
    <SectionWrapper>
      <Typography variant={TypographyVariant.h2}>Reporting</Typography>
      <ReportingContainer>
        <Row>
          <TagsSelect {...tagsSelectProps} />
          <Controller
            name="productType"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field, fieldState: { error } }) => {
              const { value, onChange, ref } = field;
              return (
                <ModelDropdown
                  key={value}
                  ref={ref}
                  name="Benefit product type"
                  apiName="benefit-product-types"
                  selected={Number(value)}
                  onChange={onChange}
                  hasError={!!error}
                  errorMessage={fieldCannotBeBlankErrorMessage}
                  width="100%"
                />
              );
            }}
          />
        </Row>
        <CountriesSelect />
      </ReportingContainer>
    </SectionWrapper>
  );
};

export default memo(ReportingSection);

const ReportingContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    background: ${theme.palette.primary.bg};
    padding: ${theme.spacing(3)};
    border-radius: 10px;
    width: 100%;
    align-items: flex-end;
  `}
`;
const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
    width: 100%;
    align-items: flex-end;
  `}
`;

const SectionWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    border: 1px solid ${theme.palette.neutral[60]};
    padding: ${theme.spacing(3)};
    border-radius: 10px;
  `}
`;
